import { lazy, Suspense } from "react";
import { Routes, Route, useLocation } from "react-router";
import { CircularProgress, Box } from "@mui/material";
import { AnimatePresence } from "framer-motion";
import PageWrapper from "./components/PageWrapper";
import ProtectedRoute from "./components/auth/ProtectedRoute";
import "./i18n/config";

const Welcome = lazy(() => import("./routes/Welcome"));
const Login = lazy(() => import("./routes/Login"));
const Dashboard = lazy(() => import("./routes/Dashboard"));
const Register = lazy(() => import("./routes/Register"));
const RecoverPassword = lazy(() => import("./routes/RecoverPassword"));
const ResetPassword = lazy(() => import("./routes/ResetPassword"));
const AcceptInvitation = lazy(() => import("./routes/AcceptInvitation"));
const Settings = lazy(() => import("./routes/Settings"));
const ForcePasswordChangePage = lazy(() => import("./routes/ForcePasswordChangePage"));

const PageLoader = () => (
  <Box sx={{ display: "flex", justifyContent: "center", alignItems: "center", minHeight: "100vh" }}>
    <CircularProgress />
  </Box>
);

const App = () => {
  const location = useLocation();
  return (
    <Suspense fallback={<PageLoader />}>
      <Box sx={{ position: 'relative', minHeight: '100vh' }}>
        {/* Persistent blue backdrop — prevents white flash during auth page transitions */}
        <Box sx={{ position: 'fixed', inset: 0, bgcolor: '#02447B', zIndex: -1 }} />
        <AnimatePresence mode="wait">
          <Routes location={location} key={location.pathname}>
            <Route path="/" element={<PageWrapper bare><Welcome /></PageWrapper>} />
            <Route path="/login" element={<PageWrapper bare><Login /></PageWrapper>} />
            <Route path="/register" element={<PageWrapper bare><Register /></PageWrapper>} />
            <Route path="/forgot-password" element={<PageWrapper bare><RecoverPassword /></PageWrapper>} />
            <Route path="/password-reset-confirm" element={<PageWrapper bare><ResetPassword /></PageWrapper>} />
            <Route
              path="/dashboard"
              element={<ProtectedRoute><Dashboard /></ProtectedRoute>}
            />
            <Route
              path="/settings"
              element={<PageWrapper><ProtectedRoute><Settings /></ProtectedRoute></PageWrapper>}
            />
            <Route
              path="/force-password-change"
              element={<PageWrapper bare><ProtectedRoute><ForcePasswordChangePage /></ProtectedRoute></PageWrapper>}
            />
            <Route path="/invitation/:hash" element={<PageWrapper bare><AcceptInvitation /></PageWrapper>} />
          </Routes>
        </AnimatePresence>
      </Box>
    </Suspense>
  );
};

export default App;
